<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="step-item">
      <div class="row mt-4">
        <div class="col-1">
          <h4><span class="badge rounded-pill bg-primary text-light">{{ index + 1 }}</span></h4>
        </div>
        <div class="col-3">
          <input
            type="text"
            class="form-control"
            v-model="item.name"
            placeholder="Optional name"
          />
        </div>
        <div class="col-3">
          <input
            type="text"
            class="form-control"
            v-model="item.qty"
            placeholder="Qty or formula"
          />
        </div>
        <div class="col-3">
          <input
            type="text"
            class="form-control"
            v-model="item.cutsize"
            placeholder="Optional cut size or formula"
          />
        </div>
        <div class="col-2 text-right">
          <button
            type="button"
            class="btn btn-danger"
            title="Delete item"
            @click.prevent="items.splice(index, 1)"
          >
            <i class="fa fa-trash"></i>
          </button>
          <button
            type="button"
            class="btn btn-secondary ml-3"
            @click.prevent="handleCopyStepItems(index)"
            title="Duplicate item"
          >
            <i class="fa fa-copy"></i>
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-1"></div>
        <div class="col-11">
          <label>
            <i class="fa fa-filter mr-2"></i> Material filter
            <small
              >(selects the material, matching one using all filters
              below)</small
            >
          </label>
          <SqlWhere
            v-for="(w, index) in item.where"
            :key="index"
            v-model="item.where[index]"
            class="mt-3"
          ></SqlWhere>
          <div>
            <button
              type="button"
              class="btn btn-link"
              @click.prevent="item.where.push({ operator: '=' })"
            >
              Add filter <i class="fa fa-filter ml-2"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-1"></div>
        <div class="col-11">
          <label>
            <i class="fa fa-calculator mr-2"></i>
            Calculations
            <small
              >(run after the material is found and can use any fields including
              material fields
              <span class="field-name">sku</span>
              <span class="field-name">name</span>
              <span class="field-name">color</span>
              <span class="field-name">w</span>
              <span class="field-name">h</span>
              <span class="field-name">d</span>)</small
            >
          </label>
          <AssemblyCalc
            v-for="(c, index) in item.calcs"
            :key="index"
            v-model="item.calcs[index]"
            class="mt-3"
            @delete="item.calcs.splice(index, 1)"
          ></AssemblyCalc>
          <div>
            <button
              type="button"
              class="btn btn-link"
              @click.prevent="item.calcs.push({ operator: '=' })"
            >
              Add calculation
              <i class="fa fa-calculator ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row step-wrapper">
      <div class="col-12">
        <button class="btn btn-link" @click.prevent="handleAddItem()">
          <i class="fa fa-plus"></i> Add item
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SqlWhere from "./SqlWhere.vue";
import AssemblyCalc from "./AssemblyCalc.vue";

export default {
  components: {
    SqlWhere,
    AssemblyCalc,
  },
  props: {
    value: Array,
  },
  computed: {
    items: {
      get: function () {
        return this.value || [];
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleCopyStepItems(index) {
      const item = JSON.parse(JSON.stringify(this.items[index]));
      this.items.splice(index, 0, item);
    },
    handleAddItem() {
      let items = this.items || [];
      items.push({
        name: "",
        qty: "",
        where: [{ operator: "=" }],
        cutsize: "",
        calcs: [],
      });
      this.$emit("input", items);
    },
  },
};
</script>

<style scoped>
.step-item {
  margin-top: 6px;
  border-bottom: 4px solid silver;
}
label {
  margin-top: 6px;
  border-bottom: 1px solid silver;
}
.field-name {
  border-radius: 4px;
  background: wheat;
  padding: 2px;
  margin: 2px;
}
</style>